import React from 'react';
import { Badge } from 'react-bootstrap';
import { modal } from '../modal/ModalEmitter';

const RepairOrderCard = ({ item }) => {
  const openRo = itemId => {
    modal.open('listEditItem', {
      action: 'edit',
      itemName: 'SMM1',
      lookupKey: itemId,
      render: 'listEditItem',
      title: `Edit Repair Order ${itemId}`,
      submitCallback: () => {},
    });
  };

  return (
    <div>
      <div>
        <Badge variant="primary">{item.customerName}</Badge>
      </div>
      <div className="card-popout" onClick={() => openRo(item.roNo)}>
        <strong>{item.roNo}</strong> <i className="fa-solid fa-arrow-up-right-from-square" />
      </div>
      <div className="description">{item.romemo}</div>
      <div><Badge variant="light">{item.rostatus}</Badge></div>
    </div>
  );
};

export default RepairOrderCard;
